export default __webpack_public_path__ + "navigation-examples-route-init-960-b6e17f4f5f07a914f207b2d9cc7b9554.png";